import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Box,
  Stack,
  Typography,
  Divider,
  IconButton,
  Button,
} from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import IosShareIcon from "@mui/icons-material/IosShare";
import OutsideClickHandler from "react-outside-click-handler";
import { Images } from "../../../assets/common";
import HMSTag from "../../../components/HMS/hms";
import ProfileMenu from "../../../components/ProfileMenu";
import { truncate, isOwnerId } from "../../../constants/function";
import useArtistProfileActions from "../hooks/useArtistProfileActions";

export default function TrendingSection({ 
  trendingMusic, 
  onPlayMusic,
  onPlayPlaylist,
  onAddToPlaylist,
  userName,
  id 
}) {
  const { t } = useTranslation("common");
  const history = useHistory();
  const [option, setOption] = useState(false);
  const [studioOption, setStudioOption] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  
  const actions = useArtistProfileActions();

  const isTrending = 
    trendingMusic?.topMusic?._id || trendingMusic?.topPlaylist?._id;

  const handleClick = (e) => {
    e.stopPropagation();
    setOption(!option);
  };

  const handleStudioShare = (e) => {
    e.stopPropagation();
    setStudioOption(!studioOption);
  };

  const handleClosed = () => {
    setOption(false);
  };

  const handleCloseShare = () => {
    setStudioOption(false);
  };

  const handleTrending = (type) => {
    if (type === "music") {
      onPlayMusic(trendingMusic?.topMusic);
    } else {
      onPlayPlaylist(trendingMusic?.topPlaylist);
    }
  };

  const handleAddToPlaylist = (e, musicId) => {
    e.stopPropagation();
    setSelectedId(musicId);
    onAddToPlaylist(musicId);
  };

  const handleCopy = (action) => {
    actions.handleCopy(action, studioOption, trendingMusic);
  };

  if (!isTrending) return null;

  return (
    <>
      <Divider sx={{ color: "#3E3E3E" }} orientation="horizontal" />
      
      <Typography sx={{ fontSize: "20px", margin: "24px 0" }}>
        {t("trending.text1")}
      </Typography>
      
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        gap="35px"
        className="mb-20 wrap"
      >
        {/* Trending Music */}
        {trendingMusic.topMusic?._id ? (
          <Box 
            onClick={() => handleTrending("music")}
            sx={{ cursor: "pointer" }}
          >
            <Stack direction="row" alignItems="center" gap="20px">
              <Stack direction="column" alignItems="end" gap="3px">
                <Typography className="fs-13 fade-text">
                  {t("trending.text2")} #1
                </Typography>
                <Typography
                  className="fs-20"
                  title={
                    trendingMusic?.topMusic?.title &&
                    trendingMusic?.topMusic?.title.length > 20
                      ? trendingMusic?.topMusic?.title
                      : ""
                  }
                >
                  {truncate(trendingMusic?.topMusic?.title, 20)}
                </Typography>
                
                <Stack direction="row">
                  <div className="_cp" onClick={(e) => handleTrending("music")}>
                    <PlayArrowRoundedIcon className="white-secondary" />
                  </div>
                  <HMSTag
                    className="white-secondary fs-14"
                    duration={trendingMusic?.topMusic?.duration}
                  />
                </Stack>

                <Stack direction="row" spacing={1}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <img
                      style={{ width: "15px", height: "15px" }}
                      src={Images.tip_player}
                    />
                    <Typography className="fs-14 white-secondary">
                      {t("analytics.card.card2")}: {trendingMusic?.topMusic?.tipEarnings}
                    </Typography>
                  </Stack>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <img
                      style={{ width: "15px", height: "15px" }}
                      src={Images.listen}
                    />
                    <Typography className="fs-14 white-secondary">
                      {t("analytics.card.card3")}: {trendingMusic?.topMusic?.listens}
                    </Typography>
                  </Stack>
                </Stack>

                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ marginTop: "15px !important" }}
                >
                  <Box sx={{ width: "130px", height: "30px" }}></Box>
                  <IconButton
                    className="__icon_button"
                    onClick={(e) => handleAddToPlaylist(e, trendingMusic?.topMusic?._id)}
                  >
                    <img src={Images.playlist_add} alt="" />
                  </IconButton>

                  <Box
                    sx={{ position: "relative" }}
                    className="_cp"
                    color="default"
                  >
                    <Stack
                      sx={{
                        width: "48px",
                        height: "36px",
                        borderRadius: "24px",
                        border: "1px solid white",
                        position: "relative",
                      }}
                      className="__play_all"
                    >
                      <IosShareIcon
                        onClick={handleClick}
                        style={{
                          color: "white",
                          marginTop: "5px",
                          alignSelf: "center",
                        }}
                        className="__play_all_play"
                      />
                    </Stack>
                    {option ? (
                      <OutsideClickHandler onOutsideClick={handleClosed}>
                        <ProfileMenu
                          right={""}
                          isHeader={true}
                          isLast={"50px !important"}
                          actions={[
                            { key: "m14", action: t("dropMenu.m14") },
                            { key: "m15", action: t("dropMenu.m15") },
                            { key: "m16", action: t("dropMenu.m16") },
                          ]}
                          handleProfileMenuChoice={(action) => {
                            handleCopy(action);
                            handleClosed();
                          }}
                        />
                      </OutsideClickHandler>
                    ) : null}
                  </Box>
                </Stack>
              </Stack>

              <Box
                sx={{
                  height: "166px",
                  width: "166px",
                  borderRadius: "15px",
                  position: "relative",
                }}
              >
                <img
                  src={
                    trendingMusic?.topMusic?.thumbnailImg?.filePath ??
                    Images.dummy1
                  }
                  alt="music"
                  height="166px"
                  width="166px"
                  style={{ borderRadius: "15px" }}
                />
                <img
                  onClick={(e) => handleTrending("music")}
                  className="__play_hover _cp"
                  src={Images.play}
                  alt="play"
                  style={{ position: "absolute", bottom: "10px", left: "10px" }}
                />
              </Box>
            </Stack>
          </Box>
        ) : null}

        {/* Divider */}
        {isTrending && window.innerWidth > 992 ? (
          <Divider
            sx={{ color: "#3E3E3E", height: "166px" }}
            orientation="vertical"
          />
        ) : null}

        {/* Trending Playlist */}
        {trendingMusic.topPlaylist?._id ? (
          <Box 
            onClick={() => handleTrending("studio")}
            sx={{ cursor: "pointer" }}
          >
            <Stack direction="row" alignItems="center" gap="20px">
              <Box
                sx={{
                  height: "166px",
                  width: "166px",
                  borderRadius: "5px",
                  position: "relative",
                }}
              >
                <img
                  src={trendingMusic?.topPlaylist?.thumbnailImg?.filePath}
                  alt="studio"
                  height="166px"
                  width="166px"
                  style={{ borderRadius: "15px" }}
                />
                <img
                  onClick={(e) => handleTrending("studio")}
                  className="__play_hover _cp"
                  src={Images.play}
                  alt="play"
                  style={{ position: "absolute", bottom: "10px", left: "10px" }}
                />
              </Box>
              
              <Stack direction="column" alignItems="start" gap="3px">
                <Typography className="fs-13 fade-text">
                  {t("trending.text3")} #1
                </Typography>
                <Typography
                  className="fs-20"
                  title={
                    trendingMusic?.topPlaylist?.title &&
                    trendingMusic?.topPlaylist?.title.length > 20
                      ? trendingMusic?.topPlaylist?.title
                      : ""
                  }
                >
                  {truncate(trendingMusic?.topPlaylist?.title, 20)}
                </Typography>
                
                <Stack direction="row">
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <img src={Images.music_hover} alt="music" />
                    <Typography className="fs-14 white-secondary">
                      {trendingMusic?.topPlaylist?.music.length}{" "}
                      {t("nftDetail.music.th1")}
                    </Typography>
                  </Stack>
                  <Divider
                    sx={{
                      color: "#3E3E3E",
                      height: "20px",
                      marginLeft: "10px",
                    }}
                    orientation="vertical"
                  />
                  <div
                    className="_cp"
                    onClick={(e) => handleTrending("studio")}
                  >
                    <PlayArrowRoundedIcon className="white-secondary" />
                  </div>
                  <HMSTag
                    className="white-secondary fs-14"
                    duration={trendingMusic?.topPlaylist?.duration}
                  />
                </Stack>

                <Stack direction="row" spacing={1}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <img
                      style={{ width: "15px", height: "15px" }}
                      src={Images.tip_player}
                    />
                    <Typography className="fs-14 white-secondary">
                      {t("analytics.card.card2")}: {trendingMusic?.topPlaylist?.tipEarnings}
                    </Typography>
                  </Stack>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <img
                      style={{ width: "15px", height: "15px" }}
                      src={Images.listen}
                    />
                    <Typography className="fs-14 white-secondary">
                      {t("analytics.card.card3")}: {trendingMusic?.topPlaylist?.listens}
                    </Typography>
                  </Stack>
                </Stack>

                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ marginTop: "15px !important" }}
                >
                  <Button
                    sx={{ whiteSpace: "pre" }}
                    variant="outlined"
                    color="default"
                    startIcon={<img src={Images.activity} alt="" />}
                    onClick={() =>
                      history.push(
                        `/app/PlaylistStatics/${trendingMusic?.topPlaylist?._id}/${trendingMusic?.topPlaylist?.owner}`
                      )
                    }
                  >
                    {t("nftDetail.detail.statics")}
                  </Button>

                  <Box
                    sx={{ position: "relative" }}
                    className="_cp"
                    color="default"
                  >
                    <Stack
                      sx={{
                        width: "48px",
                        height: "36px",
                        borderRadius: "24px",
                        border: "1px solid white",
                        position: "relative",
                      }}
                      className="__play_all"
                    >
                      <IosShareIcon
                        onClick={handleStudioShare}
                        style={{
                          color: "white",
                          marginTop: "5px",
                          alignSelf: "center",
                        }}
                        className="__play_all_play"
                      />
                    </Stack>
                    {studioOption ? (
                      <OutsideClickHandler onOutsideClick={handleCloseShare}>
                        <ProfileMenu
                          right={""}
                          isHeader={true}
                          isLast={"50px !important"}
                          actions={[
                            { key: "m14", action: t("dropMenu.m14") },
                            { key: "m15", action: t("dropMenu.m15") },
                            { key: "m16", action: t("dropMenu.m16") },
                          ]}
                          handleProfileMenuChoice={(action) => {
                            handleCopy(action);
                            handleCloseShare();
                          }}
                        />
                      </OutsideClickHandler>
                    ) : null}
                  </Box>
                </Stack>
              </Stack>
            </Stack>
          </Box>
        ) : null}

        {/* Direct Chat Button */}
        {isOwnerId(id) ? null : (
          <Box
            className="artist_dm_chat _cp"
            onClick={(e) => {
              e.stopPropagation();
              // Parent component should handle this via onChatOpen prop
            }}
          >
            <img
              title={`Chat with ${userName}`}
              style={{ width: "20px", height: "20px" }}
              src={Images.direct_chat}
              alt="Chat"
            />
          </Box>
        )}
      </Stack>

      <Divider sx={{ color: "#3E3E3E" }} orientation="horizontal" />
    </>
  );
}